export const dateTimeFormats = {
	short: {
		month: 'short', day: 'numeric', hour: 'numeric', minute: 'numeric'
	},
	medium: {
		year: 'numeric', month: 'short', day: 'numeric'
	},
	long: {
		year: 'numeric', month: 'short', day: 'numeric', hour: 'numeric', minute: 'numeric'
	},
	full: {
		year: 'numeric', month: 'short', day: 'numeric', hour: 'numeric', minute: 'numeric', second: 'numeric'
	}
};
export const messages = {
    "login.form.title": "Entrar",
    "login.form.hint.user": "Logon",
    "login.form.hint.password": "Senha",
    "login.form.checkbox.remember-me": "Lembrar de mim",
    "login.form.button.sign-in": "Entrar",
    "login.form.message.invalid-user-credentials": "Logon ou senha está incorreto",
    "login.form.message.account-temporarily-locked": "Sua conta está temporariamente bloqueada, retorne em 5 minutos",
    "login.form.message.user-required": "Digite um logon",
    "login.form.message.password-required": "Digite uma senha",
    "login.form.button.forgot-password": "Esqueceu sua senha?",
    "error.mfa-required.title": "Configurar 2FA",
    "error.mfa-required.message1": "A autenticação de dois fatores (2FA) é necessária para proteger sua conta.",
    "error.mfa-required.message2": "Você será redirecionado para as configurações da sua conta no dashboard online. Ative a 2FA, siga as instruções de configuração e, em seguida, volte aqui.",
    "error.mfa-required.learnMore": "Saiba mais sobre a 2FA",
    "error.mfa-required.continue": "Continuar",
    "error.root-admin-login.title": "Erro 403 – proibido",
    "error.root-admin-login.message": "Você está conectado como Administrador somente leitura. Para acessar o console do Web Recovery, entre como usuário de locatário do cliente ou administrador",
    "error.server-busy.message": "O servidor está ocupado, tente mais tarde.",
    "error.network-connection.title": "Erro de conexão de rede",
    "error.network-connection.message": "Verifique a conexão com a Internet e tente novamente.",
    "error.internal-server-error.title": "Erro interno do servidor",
    "error.internal-server-error.message": "Para resolver o erro, entre em contato com o suporte com os detalhes do erro:",
    "error.internal-server-error.copy.button": "Copiar"
};
